<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">รายการสินค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายการสินค้า
      </v-card-title>
      <v-col v-if="disableTable === false" cols="12" md="6" sm="12" class="">
        <v-text-field class="" v-model="search" placeholder="ค้นหารายการสินค้า" outlined dense hide-details>
          <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
        </v-text-field>
      </v-col>
      <v-col cols="12" :class="MobileSize || IpadSize ? 'pb-0 pt-0' : 'pt-3 pb-3'" v-if="disableTable === false">
        <v-row dense>
          <v-col cols="12" md="6" sm="12" :class="MobileSize || IpadSize ? 'pt-3 pb-0' : 'pt-5'">
            <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการจำนวนสินค้าทั้งหมด {{ showCountRequest }} รายการ</span>
          </v-col>
          <v-col cols="12" md="6" sm="12" :align="MobileSize ? 'center' : 'right'">
            <v-btn @click="importProduct()" :block="MobileSize" dense dark outlined color="#27AB9C" :class="!MobileSize ? 'ml-1 mt-2 mr-2 white--tex' : 'mt-2 white--tex'" v-if="is_gracz !== 'yes'">
              <v-icon small>mdi-file-download-outline</v-icon>
              ดึงข้อมูลจากระบบซื้อขาย
            </v-btn>
            <v-btn @click="exportExcel()" :block="MobileSize" dense dark outlined color="#27AB9C" :class="!MobileSize ? 'ml-1 mt-2 white--tex' : 'mt-2 white--tex'" v-if="is_gracz === 'yes'">
              <v-icon small>mdi-file-download-outline</v-icon>
              ส่งออกข้อมูล
            </v-btn>
            <v-btn :class="!MobileSize ? 'ml-1 mt-2 mr-2' : 'mt-2'" :block="MobileSize" color="#27AB9C" dark outlined @click="$refs.file_input.click()" v-if="is_gracz === 'yes'">
              <v-icon small>mdi-file-upload-outline</v-icon>นำเข้าข้อมูล
            </v-btn>
            <input type="file" @click="event => event.target.value = null" @change="previewFiles($event)" ref="file_input" accept=".xls, .xlsx" style="display: none;"/>
            <v-overlay :value="loading" style="text-align:center; z-index: 99999;">
              <v-card width="450px" height="150px" class="pa-3" color="white" style="opacity: 80%;">
                <v-progress-circular indeterminate size="64" color="#00B500"></v-progress-circular>
                <p style="font-weight: 600; font-size: 18px; line-height: 24px; color: #333333; margin-top: 30px;">กำลังนำเข้าข้อมูล กรุณารอสักครู่</p>
              </v-card>
            </v-overlay>
            <v-btn @click="gotoCreate()" color="#27AB9C" :block="MobileSize" class="white--text mt-2">
              <v-icon>mdi-plus-circle-outline</v-icon>
              เพิ่มสินค้า
            </v-btn>
          </v-col>
          <!-- <v-col cols="12" md="12" sm="12" :class="MobileSize || IpadSize ? 'pt-3 pb-0' : 'pt-5'" v-if="is_gracz !== 'yes'">
            <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการจำนวนสินค้าทั้งหมด {{ showCountRequest }} รายการ</span>
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12" v-if="disableTable === false">
        <v-data-table
        :headers="MobileSize ? headersMobile : headers"
        :items="productList"
        :search="search"
        :page.sync="page"
        @pagination="countRequest"
        no-results-text="ไม่พบรายการสินค้า"
        no-data-text="ไม่มีรายการสินค้า"
        :footer-props="{'items-per-page-text':'จำนวนแถว', 'items-per-page-options': [10, 20, 30, 40, 50, 100]}"
        @update:items-per-page="itemsPerPage"
        :items-per-page="5"
        :hide-default-header="MobileSize ? true : false"
        class="elevation-1 fontTableData"
        >
          <template v-slot:[`item.product_image`]="{ item }" v-if="!MobileSize">
            <v-card width="100px" height="100px" class="d-flex ma-5" :elevation="0">
              <v-img :src="item.product_image" v-if="item.product_image !== ''"></v-img>
              <v-img src="@/assets/NoImage.png" v-else></v-img>
            </v-card>
          </template>
          <template v-slot:[`item.stock_status`]="{ item }" v-if="!MobileSize">
              <span v-if="item.stock_status ==='in stock'">
                <v-chip small color="#F0F9EE" text-color="#1AB759">พร้อมขาย</v-chip>
              </span>
              <span v-else>
                <v-chip small color="#F9EEEE" text-color="#F5222D">สินค้าหมด</v-chip>
              </span>
          </template>
          <!-- <template v-slot:[`item.stock_count`]="{ item }" v-if="!MobileSize">
              <span v-if="item.stock_status ==='in stock'">
                <v-chip small color="#F0F9EE" text-color="#1AB759">พร้อมขาย</v-chip>
              </span>
              <span v-else>
                <v-chip small color="#F9EEEE" text-color="#F5222D">สินค้าหมด</v-chip>
              </span>
          </template> -->
          <!-- <template v-slot:[`item.stock_count`]="{ item }" v-if="!MobileSize">
            <v-chip small color="#F0F9EE" text-color="#1AB759">พร้อมขาย{{item.stock_count}}</v-chip>
          </template> -->
          <template v-slot:[`item.action`]="{ item }" v-if="!MobileSize">
            <v-row>
              <v-col>
                <v-tooltip top color="#27AB9C">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      x-small @click="switchStatus(item.product_id)"
                      style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                      outlined class="pt-4 pb-4"
                      :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                      >
                      <v-icon v-if="item.product_status === 'active'" color="#27AB9C">mdi-eye</v-icon>
                      <v-icon v-else color="#27AB9C">mdi-eye-off</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="item.product_status === 'active'">ซ่อนสินค้า</span>
                  <span v-else>แสดงสินค้า</span>
                </v-tooltip>
                <v-tooltip top color="#27AB9C">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      x-small @click="gotoEdit(item.product_id)"
                      style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                      outlined class="pt-4 pb-4 mx-2"
                      :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                      >
                      <v-icon color="#27AB9C" :size="18">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>แก้ไข</span>
                </v-tooltip>
                <v-tooltip top color="#27AB9C">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="item.have_order === 'yes'"
                      v-bind="attrs" v-on="on"
                      x-small @click="openDialogConfirmDelete(item.product_id)"
                      style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                      outlined class="pt-4 pb-4"
                      :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                      >
                      <v-icon color="#27AB9C" :size="18">mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>ลบ</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>

          <!-- MobileSize -->
            <template v-slot:item="{ item }" v-if="MobileSize">
              <v-card class="pa-4 mb-2">
                <v-row class="mt-1">
                  <v-col cols="6" xs="3" style="width: 200px; text-overflow: ellipsis; overflow: hidden; display: inline-block; white-space: nowrap; text-align: left; font-weight: 700; font-size: 16px; line-height: 24px; color: #333333;">
                    <span style="">{{ item.product_name }}</span>
                  </v-col>
                  <v-col cols="6" xs="9">
                    <v-row justify="end">
                      <!-- <v-col> -->
                        <v-tooltip top color="#27AB9C">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs" v-on="on"
                              x-small @click="switchStatus(item.product_id)"
                              style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                              outlined class="pt-4 pb-4"
                              :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                              >
                              <v-icon v-if="item.product_status === 'active'" color="#27AB9C">mdi-eye</v-icon>
                              <v-icon v-else color="#27AB9C">mdi-eye-off</v-icon>
                            </v-btn>
                          </template>
                          <span v-if="item.product_status === 'active'">ซ่อนสินค้า</span>
                          <span v-else>แสดงสินค้า</span>
                        </v-tooltip>
                        <v-tooltip top color="#27AB9C">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs" v-on="on"
                              x-small @click="gotoEdit(item.product_id)"
                              style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                              outlined class="pt-4 pb-4 mx-2"
                              :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                              >
                              <v-icon color="#27AB9C" :size="18">mdi-pencil-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>แก้ไข</span>
                        </v-tooltip>
                        <v-tooltip top color="#27AB9C">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :disabled="item.have_order === 'yes'"
                              v-bind="attrs" v-on="on"
                              x-small @click="openDialogConfirmDelete(item.product_id)"
                              style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                              outlined class="pt-4 pb-4"
                              :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                              >
                              <v-icon color="#27AB9C" :size="18">mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>ลบ</span>
                        </v-tooltip>
                      <!-- </v-col> -->
                    </v-row>
                  </v-col>
                </v-row>
                 <v-row class="mt-1">
                  <v-col cols="6" xs="3" style="width: 200px; text-overflow: ellipsis; overflow: hidden; display: inline-block; white-space: nowrap; text-align: left; font-weight: 700; font-size: 16px; line-height: 24px; color: #333333;">
                    <span style="">{{ item.product_sale_status }}</span>
                  </v-col>
                 </v-row>
                <v-row dense class="px-0 mt-2">
                  <v-col cols="4" class="">
                      <v-img width="150px" height="110px" :src="item.product_image" v-if="item.product_image !== ''" contain></v-img>
                      <v-img width="150px" height="110px" src="@/assets/NoImage.png" v-else></v-img>
                  </v-col>
                  <v-col cols="8" class="mt-2" align="end">
                    <v-row>
                      <v-col cols="4" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">รหัส SKU</v-col>
                      <v-col cols="8" class="pl-0" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ item.sku }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">สถานะ</v-col>
                        <v-col cols="8" class="pl-0" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                      <span v-if="item.stock_status == 'in stock'">
                      <v-chip small color="#F0F9EE" text-color="#1AB759">พร้อมขาย</v-chip>
                      </span>
                      <span v-else>
                      <v-chip small color="#F9EEEE" text-color="#F5222D">สินค้าหมด</v-chip>
                      </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">สินค้าพร้อมขาย</v-col>
                      <v-col cols="8" class="pl-0" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ item.stock_count }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">ราคา</v-col>
                      <v-col cols="8" class="pl-0">{{ item.product_price_range }}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </template>

          <!-- <template v-slot:[`item.actionMobile`]="{ item }" v-if="MobileSize">
            <v-row class="mt-1">
              <v-col cols="6" xs="3" style="width: 200px; text-overflow: ellipsis; overflow: hidden; display: inline-block; white-space: nowrap; text-align: left; font-weight: 700; font-size: 16px; line-height: 24px; color: #333333;">
                <span style="">{{ item.product_name }}</span>
              </v-col>
              <v-col cols="6" xs="9">
                <v-row justify="end">
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs" v-on="on"
                          x-small @click="switchStatus(item.product_id)"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          outlined class="pt-4 pb-4"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                          >
                          <v-icon v-if="item.product_status === 'active'" color="#27AB9C">mdi-eye</v-icon>
                          <v-icon v-else color="#27AB9C">mdi-eye-off</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="item.product_status === 'active'">ซ่อนสินค้า</span>
                      <span v-else>แสดงสินค้า</span>
                    </v-tooltip>
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs" v-on="on"
                          x-small @click="gotoEdit(item.product_id)"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          outlined class="pt-4 pb-4 mx-2"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                          >
                          <v-icon color="#27AB9C" :size="18">mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :disabled="item.have_order === 'yes'"
                          v-bind="attrs" v-on="on"
                          x-small @click="openDialogConfirmDelete(item.product_id)"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          outlined class="pt-4 pb-4"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                          >
                          <v-icon color="#27AB9C" :size="18">mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>ลบ</span>
                    </v-tooltip>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <template v-slot:[`item.productMobile`]="{ item }" v-if="MobileSize">
            <v-row dense class="px-0">
              <v-col cols="3" class="">
                  <v-img width="150px" height="110px" :src="item.product_image" v-if="item.product_image !== ''" contain></v-img>
                  <v-img width="150px" height="110px" src="@/assets/NoImage.png" v-else></v-img>
              </v-col>
              <v-col cols="9" class="mt-2">
                <v-row>
                  <v-col cols="3" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">รหัส SKU</v-col>
                  <v-col cols="9" class="pl-0">{{ item.sku }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" align="left" class="pr-0" style="text-align: left; font-weight: 700; font-size: 12px; line-height: 24px; color: #333333;">ราคา</v-col>
                  <v-col cols="9" class="pl-0">{{ item.product_price_range }}</v-col>
                </v-row>
              </v-col>
            </v-row>
          </template> -->
        </v-data-table>
      </v-col>
      <v-col cols="12" v-if="disableTable === true" align="center">
        <div class="my-5">
          <v-img src="@/assets/emptypo.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
        </div>
        <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสินค้า</b></h2>
      </v-col>

      <!-- dialog comfirm Delete -->
      <v-dialog max-width="464px"  v-model="dialogConfirmDelete" persistent>
        <v-card max-height="300px" align="center" class="rounded-lg">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">ลบสินค้า</font></span>
            <v-btn
              icon
              dark
              @click="dialogConfirmDelete = false"
              >
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-icon size="80" color="#E9A016">mdi-alert-circle-outline</v-icon><br/>
          <v-card-text>
            <span class="fontModal">
              คุณลบสินค้า <b>{{productSelect.product_name}}</b><br/>
              ต้องการทำรายการต่อใช่ หรือไม่
            </span>
          </v-card-text>
          <v-card-actions >
        <v-row justify="center" dense class="mb-4">
          <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="dialogConfirmDelete = false">ยกเลิก</v-btn>
          <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="deleteProduct()">ตกลง</v-btn>
        </v-row>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog Delete Success -->
      <v-dialog v-model="dialogSuccess" persistent width="373">
        <v-card style="background: #FFFFFF; border-radius: 4px;" min-height="246px">
          <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px">
              <font color="#27AB9C">ลบสินค้า</font>
            </span>
            <v-btn icon dark @click="closeDialogConfirmDelete()">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-row justify="center" no-gutters dense>
                <v-col cols="12" align="center">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONShop/successIcon.png" contain max-height="70" max-width="70"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="mt-6">
                  <p style="font-weight: 500; font-size: 14px; line-height: 22px; color: color: #333333;" class="pt-0 mt-0">เสร็จสิ้น</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import { Decode, Encode } from '@/services'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      is_gracz: '',
      // table data
      selected: [],
      selectedProductID: [],
      disableTable: false,
      search: '',
      page: 1,
      itemsPerPage: 5,
      showCountRequest: '',
      headers: [
        { text: 'รูปภาพสินค้า', value: 'product_image', filterable: false, sortable: false, align: 'center', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อสินค้า', value: 'product_name', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัส  SKU', value: 'sku', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'stock_status', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'สินค้าพร้อมขาย', value: 'stock_count', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'ราคา', value: 'product_price_range', filterable: false, align: 'start', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'action', filterable: false, sortable: false, align: 'center', width: '160px', class: 'backgroundTable fontTable--text' }
      ],
      headersMobile: [
        { text: 'ชื่อสินค้า', value: 'product_name', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัส  SKU', value: 'sku', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'stock_status', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' },
        { text: 'สินค้าพร้อมขาย', value: 'stock_count ', filterable: true, sortable: false, align: 'start', width: '200px', class: 'backgroundTable fontTable--text' }
        // { text: '', value: 'actionMobile', filterable: false, sortable: false, align: 'center', width: '160px', class: 'pa-0' },
        // { text: '', value: 'productMobile', filterable: false, sortable: false, align: 'center', width: '200px', class: 'backgroundTable fontTable--text' }
      ],
      productList: [],
      productSelect: [],

      // delete
      dialogConfirmDelete: false,
      dialogSuccess: false,

      // export data
      PathDownloadForm: '',
      auth: '',
      loading: false
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/ProductListSaleOrderMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ProductListSaleOrder').catch(() => {})
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  async created () {
    this.$EventBus.$emit('changeNav')
    // if (localStorage.getItem('oneData') === null) {
    //   this.$router.push({ path: '/' }).catch(() => {})
    // }
    this.$store.commit('openLoader')

    this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
    this.seller_shop_id = this.userDetailSelling.seller_shop_id
    this.is_gracz = this.userDetailSelling.is_gracz

    await this.$store.dispatch('actionsGraczUserDetail')
    var response = await this.$store.state.ModuleGraczUser.stateGraczUserDetail
    if (response.message === 'Not access this function.') {
      await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
      window.location.assign('/')
    }

    const GetToken = () => {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
        const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
        const auth = {
          headers: { Authorization: `Bearer ${oneData.user.access_token}` }
        }
        return auth
      }
    }
    const auth = await GetToken()
    this.auth = auth.headers.Authorization
    this.auth = this.auth.substring(7)
    this.getData()
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    gotoCreate () {
      if (this.MobileSize) {
        this.$router.push({ path: `/Order/ManageProductSaleOrderMobile?Status=Create&ShopID=${this.seller_shop_id}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/ManageProductSaleOrder?Status=Create&ShopID=${this.seller_shop_id}` }).catch(() => {})
      }
    },
    gotoEdit (productID) {
      if (this.MobileSize) {
        this.$router.push({ path: `/Order/ManageProductSaleOrderMobile?Status=Edit&ShopID=${this.seller_shop_id}&ProductID=${productID}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/ManageProductSaleOrder?Status=Edit&ShopID=${this.seller_shop_id}&ProductID=${productID}` }).catch(() => {})
      }
    },
    countRequest (pagination) {
      this.showCountRequest = pagination.itemsLength
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ['กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning']
      } else if (msg === 'The user was not found in the company.') {
        return ['คุณไม่ได้อยู่ในบริษัทใดเลย', 'warning']
      } else if (msg === 'Company not found.') {
        return ['ไม่พบข้อมูลบริษัทในระบบ', 'warning']
      } else if (msg === 'You are not in this Company.') {
        return ['คุณไม่ได้อยู่ในบริษัทนี้', 'warning']
      } else if (msg === 'Data missing. Please check your [" company_id "] and try again.') {
        return ['ข้อมูลขาดหาย โปรดเช็ค [ รหัสบริษัท ] แล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Company Permission not found.') {
        return ['ไม่พบสิทธิ์ผู้ใช้องค์กรนี้', 'warning']
      } else if (msg === 'This is not you Company Permission.') {
        return ['สิทธิ์ผู้ใช้องค์กรนี้ไม่ใช่ของคุณ', 'warning']
      } else if (msg === 'This Permission not in your Company.') {
        return ['สิทธิ์ผู้ใช้องค์กรนี้ไม่ได้อยู่ในองค์กรของคุณ', 'warning']
      } else if (msg === 'Data missing. Please check your [" com_perm_id "] and try again.') {
        return ['ข้อมูลขาดหาย โปรดเช็ค [ รหัสสิทธิ์ผู้ใช้องค์กร ] แล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Purchaser not found.') {
        return ['ไม่พบข้อมูลผู้ซื้อองค์กร', 'warning']
      } else if (msg === 'An error has occurred. Please try again in an hour or two.') {
        return ['กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', 'error']
      } else {
        return [msg, 'error']
      }
    },
    async getData () {
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczListProduct
      if (response.result === 'SUCCESS') {
        this.productList = response.data.list_product
      } else {
        if (response.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
      this.$store.commit('closeLoader')

      // console.log('data send to API', data)
      // console.log('resp from to API', response)
    },

    // action btn
    async switchStatus (productId) {
      this.productList.forEach(element => {
        if (element.product_id === productId) {
          this.productSelect = element
        }
      })
      var data = {
        seller_shop_id: this.seller_shop_id,
        product_id: this.productSelect.product_id
      }
      await this.$store.dispatch('actionsGraczChangeStatusProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczChangeStatusProduct
      if (response.result === 'SUCCESS') {
        this.getData()
      } else {
        if (response.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
      console.log('data send to API', data)
      console.log('resp from to API', response)
    },
    openDialogConfirmDelete (productId) {
      this.dialogConfirmDelete = true
      this.productList.forEach(element => {
        if (element.product_id === productId) {
          this.productSelect = element
        }
      })
    },
    async deleteProduct () {
      // this.$store.commit('openLoader')
      var data = {
        product_id: this.productSelect.product_id
      }
      await this.$store.dispatch('actionsGraczDeleteProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczDeleteProduct
      // var response = { result: 'SUCCESS' }
      if (response.result === 'SUCCESS') {
        this.dialogConfirmDelete = false
        this.dialogSuccess = true
      } else {
        if (response.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
        this.dialogConfirmDelete = false
        this.closeDialogConfirmDelete()
      }
      // this.$store.commit('closeLoader')
      console.log('data send to API Delete', data)
      console.log('res from API Delete', response)
    },
    closeDialogConfirmDelete () {
      // delete success
      this.dialogSuccess = false
      this.productSelect = []
      this.getData()
    },

    selectAllToggle (props) {
      console.log('selectall', props)
      if (this.selected.length === this.productList.length) {
        this.selected = []
      } else {
        this.selected = this.productList
      }
      console.log(this.selected)
    },
    // import form panit
    importProduct () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/ImportPanitProductMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ImportPanitProduct' }).catch(() => {})
      }
    },
    // export file
    async exportExcel () {
      this.selectedProductID = []
      this.PathDownloadForm = `${process.env.VUE_APP_BACK_END}api/g/export_product_price/${this.seller_shop_id}/[${this.selectedProductID}]/${this.auth}`
      window.location.href = this.PathDownloadForm

      this.$store.commit('openLoader')
      var data = {
        seller_shop_id: this.seller_shop_id,
        auth: this.auth,
        selected: this.selectedProductID
      }
      await this.$store.dispatch('actionsGraczExportProduct', data)
      this.$store.commit('closeLoader')
    },

    // import file
    previewFiles (e) {
      var files = e.target.files
      console.log(files)
      var f = files[0]
      // var dataJ
      var reader = new FileReader()
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result)
        console.log(data)
        var workbook = XLSX.read(data, { type: 'array' })
        console.log(workbook)
        const sheetName = workbook.SheetNames[0]
        /* DO SOMETHING WITH workbook HERE */
        const worksheet = workbook.Sheets[sheetName]
        console.log(worksheet)
        console.log(XLSX.utils.sheet_to_json(worksheet))
        this.importCustomerData(XLSX.utils.sheet_to_json(worksheet))
      }
      reader.readAsArrayBuffer(f)
    },
    async importCustomerData (excelJson) {
      this.loading = true
      var sendData
      const data = {
        seller_shop_id: this.seller_shop_id,
        file: excelJson,
        staus: 'preview'
      }
      await this.$store.dispatch('actionsGraczImportProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczImportProduct
      if (response.code !== 500) {
        if (response.message === 'Import Product Price Success.') {
          this.loading = false
          this.$swal.fire({ icon: 'success', text: 'นำเข้าข้อมูลสินค้าจากไฟล์ Excel สำเร็จ', showConfirmButton: false, timer: 2000 })
          sendData = { response: response.message, data: response.data }
          localStorage.setItem('previewCheckImportProduct', Encode.encode(sendData))
          this.goToPreviewImportExcelProduct()
        } else {
          this.loading = false
          if (response.message === 'Fail To Import Product Price.') {
            this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลสินค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
            sendData = { response: response.message, data: response.data }
            console.log(sendData)
            localStorage.setItem('previewCheckImportProduct', Encode.encode(sendData))
            this.goToPreviewImportExcelProduct()
          } else if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
        }
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลสินค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
      }
    },
    goToPreviewImportExcelProduct () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/ImportProductMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ImportProduct' }).catch(() => {})
      }
    }
  }
}
</script>
<style scoped>
.fontSizeTitle {
  font-weight: 600; font-size: 18px; line-height: 24px; color: #333333;
}
.fontTableHeader {
  font-weight: 400; font-size: 16px; line-height: 24px; color: #27AB9C !important;
}
.fontModal {
  font-weight: 400; font-size: 16px; line-height: 22px; color: #636363 !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: #27AB9C !important;
}
.v-data-table>.v-data-tablewrapper .v-data-tablemobile-table-row {
  margin: 10px;
  border: 1px solid #ededed;
  display: block;
}
</style>
<style>
.v-application--is-ltr .v-data-footer__select {
  margin-right: 0px !important;
}
</style>

<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(7) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(7) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 11;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
  // ::v-deep .elevation-1 th:first-of-type {
  //   background-color: #E6F5F3;
  // }
</style>
